
import Vue from 'vue';

export default Vue.extend({
  props: {
    iconOnly: { type: Boolean, required: true },
  },
  data() {
    return {
      allLocales: this.$i18n.locales as Array<any>,
      currentLocale: this.$i18n.locale,
      switchLabel: null as any,
      countries: [] as Array<any>,
      showModal: false,
      isMobile: false,
    };
  },
  created() {
    this.switchLabel = {
      country: this.allLocales.find((locale: any) => locale.code === this.currentLocale).countryName,
      lang: this.allLocales.find((locale: any) => locale.code === this.currentLocale).languageName,
    };

    this.allLocales.forEach((locale: any) => {
      if (!this.countries.find((item: any) => item.name === locale.countryName)) {
        this.countries.push({
          name: locale.countryName,
          languages: this.allLocales.filter((filteredLocale: any) => filteredLocale.countryName === locale.countryName),
        });
      }
    });
  },
  mounted() {
    window.addEventListener('resize', this.updateIsMobile);
    this.updateIsMobile();
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.updateIsMobile);
  },

  methods: {
    changeLanguage(language: any) {
      window.location.href = `/${language.code}/`;
      this.switchLabel = {
        country: this.allLocales.find((locale: any) => locale.code === language.code).countryName,
        lang: this.allLocales.find((locale: any) => locale.code === language.code).languageName,
      };
    },

    updateIsMobile() {
      this.isMobile = window.innerWidth < 1024;
    },

    openModal() {
      this.showModal = true;
      window.addEventListener('modalClose', this.closeModal, { passive: true });
    },

    closeModal() {
      this.showModal = false;

      window.removeEventListener('modalClose', this.closeModal);
    },
  },
});
